import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  TBulkAssignAgentsPayload,
  TBulkAssignAgentsResponse,
} from '~/features/agents/models'
import { queryKeys } from '~/features/agents/utils'
import { EHttpService, EServerPath, TErrorResponse } from '~/models/api'
import HttpService from '~/services/http'
import { HttpServiceBaseResponse } from '~/services/http/models'
import { store } from '~/store'

const bulkAssignAgents = async ({
  orgId,
  payload,
}: {
  orgId: string
  payload: TBulkAssignAgentsPayload
}) =>
  HttpService.post<TBulkAssignAgentsResponse>(
    {
      path: EServerPath.agentsAssignments,
      query: { orgId },
      payload,
    },
    EHttpService.agent,
  )

function useBulkAssignAgents() {
  const queryClient = useQueryClient()
  const orgId = store((state) => state.user.organizationId) || ''

  return useMutation<
    HttpServiceBaseResponse<TBulkAssignAgentsResponse>,
    TErrorResponse,
    TBulkAssignAgentsPayload
  >({
    mutationFn: (payload) => bulkAssignAgents({ orgId, payload }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.agents({}),
        exact: false,
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.agentsByOrganization(orgId),
        exact: false,
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.locations(orgId),
      })
    },
  })
}

export default useBulkAssignAgents
